import { Injectable } from '@angular/core';
import { ToastrService  } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  // toaster
  position = 'top-right';
  title: string;
  msg: string;
  showClose = true;
  timeout = 5000;
  theme = 'bootstrap';
  type = 'default';
  closeOther = false;
  // toaster
  toastRef;
  constructor(private toastr: ToastrService
  ) {

  }
  showToast = (options: any) => {
    this.toastr.show(options.title, null, {
      disableTimeOut: true,

      tapToDismiss: false,
      toastClass: "toast border-red",
      closeButton: true,
      positionClass: options.position
    }, options.title);
  }

  removeToast = () => {
    this.toastr.clear();
  }
  //toaster
  addToast(options: any) {
    this.removeToast();
    if (options.type == "success") {
      this.toastr.success(options.msg, options.title, {
        timeOut: options.timeout,
        closeButton: true,
        enableHtml: true
      });
    }
    else if (options.type == "error") {
      this.toastr.error(options.msg, options.title, {
        timeOut: options.timeout,
        closeButton: true,
        enableHtml: true
      });
    }
    else if (options.type == "warning") {
      this.toastr.warning(options.msg, options.title, {
        timeOut: options.timeout,
        closeButton: true,
        enableHtml: true
      });
    }
    else if (options.type == "info") {
      this.toastr.info(options.msg, options.title, {
        timeOut: options.timeout,
        closeButton: true,
        enableHtml: true
      });
    }
    //if (options.closeOther) {
    //  //this.toastyService.clearAll();
    //}
    //this.position = options.position ? options.position : this.position;
    //const toastOptions: ToastOptions = {
    //  title: options.title,
    //  msg: options.msg,
    //  showClose: options.showClose,
    //  timeout: options.timeout,
    //  theme: options.theme,
    //  onAdd: (toast: ToastData) => {
    //    /* added */

    //  },
    //  onRemove: (toast: ToastData) => {
    //    /* removed */
    //  }
    //};

    //switch (options.type) {
    //  case 'default': this.toastyService.default(toastOptions); break;
    //  case 'info': this.toastyService.info(toastOptions); break;
    //  case 'success': this.toastyService.success(toastOptions); break;
    //  case 'wait': this.toastyService.wait(toastOptions); break;
    //  case 'error': this.toastyService.error(toastOptions); break;
    //  case 'warning': this.toastyService.warning(toastOptions); break;
    //}
  }
  addToastWithoutClear(options: any) {
    if (options.type == "info") {
      this.toastr.info(options.msg, options.title, {
        timeOut: options.timeout,
        closeButton: true,
        enableHtml: true
      });
    }
  }
  clearAllToast() {
    this.toastr.clear();
  }
  //toaster
  //}
}
